import { Text, View, StyleSheet, Image } from '@react-pdf/renderer'
import { base64ToBlobUrl } from '../_data/helper'
import { PDFReportFeatureProps } from '..'
import { pdfFontSize, pdfPadding } from '../_data/style-define'

const styles = StyleSheet.create({
  image: {
    width: '100%',
    height: 240,
    marginBottom: pdfPadding.medium,
  },
  ranchImage: {
    width: '100%',
    height: 200,
    marginBottom: pdfPadding.medium,
  },
  title: {
    color: '#00B5A3',
    fontSize: pdfFontSize.title,
    fontWeight: 'bold',
    marginBottom: pdfPadding.medium,
  },
  infoRow: {
    marginBottom: pdfPadding.xxSmall,
    fontWeight: 'bold',
    fontSize: pdfFontSize.text,
  },
  label: {
    fontWeight: 'bold',
  },
  badgeContainer: {
    flexDirection: 'row',
    gap: pdfPadding.small,
    marginLeft: pdfPadding.small,
  },
  badge: {
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: '#FFB800',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    fontSize: 10,
  },
  badgeRed: {
    backgroundColor: '#FF6B6B',
  },
  paragraph: {
    marginTop: pdfPadding.small,
    fontSize: pdfFontSize.text,
    lineHeight: 1.6,
  },
})

export default function ExecutiveSummaryDetail({
  data,
  ability,
  type,
}: PDFReportFeatureProps) {
  if (!ability.subbasinInformation) {
    return null
  }

  if (type === 'parcel') {
    return (
      <View style={{ marginBottom: pdfPadding.large }}>
        <Image
          src={base64ToBlobUrl(data.property.data.imgUrls[0])}
          style={styles.image}
        />

        {Object.entries(data.executive_summary).map(
          ([subbasinNo, value], index) => {
            const item: any = value
            return (
              <View key={`executive_summary${index}`}>
                <View>
                  <Text style={styles.title}>
                    Water District(s) Executive Summary
                  </Text>
                  {item.wd_info.length > 0 && (
                    <>
                      {item.wd_info.map((item: any) => (
                        <View
                          key={item.wd_name}
                          style={{ marginBottom: pdfPadding.medium }}
                        >
                          <Text style={styles.infoRow}>
                            <Text style={styles.label}>Water District: </Text>
                            {item.wd_name} {`(${subbasinNo})`}
                          </Text>

                          <Text style={styles.paragraph}>
                            {item.wd_executive_summary}
                          </Text>
                        </View>
                      ))}
                    </>
                  )}
                </View>
                <View>
                  <Text style={styles.title}>Subbasin Executive Summary</Text>
                  <View style={styles.infoRow}>
                    <Text>
                      <Text style={styles.label}>Subbasin: </Text>
                      {item.subbasin_name} ({subbasinNo})
                    </Text>
                  </View>
                  {item.gsa_info.length > 0 && (
                    <View style={styles.infoRow}>
                      <Text>
                        <Text style={styles.label}>GSA: </Text>
                        {item.gsa_info
                          .map((gsa: any) => gsa.gsa_name)
                          .join(', ')}
                      </Text>
                    </View>
                  )}
                  <View style={styles.infoRow}>
                    <Text style={styles.label}>
                      GSP Approval Status: {item.gsp_status}
                    </Text>
                  </View>

                  {ability.subbasinExecutiveSumary && (
                    <Text style={styles.paragraph}>
                      {item.subbasin_status_update}
                    </Text>
                  )}
                  {ability.subbasinExecutiveSumary && (
                    <Text style={styles.paragraph}>
                      {item.executive_summary}
                    </Text>
                  )}
                </View>
              </View>
            )
          }
        )}
      </View>
    )
  }

  const imageUrl = data['aerial-view']
  return (
    <View style={{ marginBottom: pdfPadding.large }}>
      <Image src={imageUrl} style={styles.ranchImage} />

      {Object.entries(data.executive_summary).map(
        ([subbasinNo, value], index) => {
          const item: any = value
          const hydroLogicInfo = item.hydrologic_info
          return (
            <View key={`executive_summary${index}`}>
              <View>
                <Text style={styles.title}>
                  Water District(s) Executive Summary
                </Text>
                {item.wd_info.length > 0 && (
                  <>
                    {item.wd_info.map((item: any) => (
                      <View
                        key={item.wd_name}
                        style={{ marginBottom: pdfPadding.medium }}
                      >
                        <Text style={styles.infoRow}>
                          <Text style={styles.label}>Water District: </Text>
                          {item.wd_name} {`(${subbasinNo})`}
                        </Text>

                        <Text style={styles.paragraph}>
                          {item.wd_executive_summary}
                        </Text>
                      </View>
                    ))}
                  </>
                )}
              </View>
              <View>
                <Text style={styles.title}>Subbasin Executive Summary</Text>
                <View style={styles.infoRow}>
                  <Text>
                    <Text style={styles.label}>Subbasin: </Text>
                    {hydroLogicInfo.subbasin_name} ({subbasinNo})
                  </Text>
                </View>
                {item.gsa_info.length > 0 && (
                  <View style={styles.infoRow}>
                    <Text>
                      <Text style={styles.label}>GSA: </Text>
                      {item.gsa_info.map((gsa: any) => gsa.gsa_name).join(', ')}
                    </Text>
                  </View>
                )}
                <View style={styles.infoRow}>
                  <Text style={styles.label}>
                    GSP Approval Status: {hydroLogicInfo.gsp_status}
                  </Text>
                </View>

                {ability.subbasinExecutiveSumary && (
                  <Text style={styles.paragraph}>
                    {hydroLogicInfo.subbasin_status_update}
                  </Text>
                )}
                {ability.subbasinExecutiveSumary && (
                  <Text style={styles.paragraph}>
                    {hydroLogicInfo.executive_summary}
                  </Text>
                )}
              </View>
            </View>
          )
        }
      )}
    </View>
  )
}
